/* eslint
    no-empty-function: "warn",
    consistent-return: "warn"
*/

import { invoke } from '@shared/easyfy.decorators';
import { globalEvent, element } from '@shared/easyfy.core';
import { addCss, removeCss } from '@shared/easyfy.utils';

export default class PageSubCategoryExpander {
  static Instance: PageSubCategoryExpander;

  InitElements() {
    PageSubCategoryExpander.Instance = this;
    globalEvent({
      type: 'click',
      event: {
        action: 'show-all-sub-categories',
        callback: PageSubCategoryExpander.expandSubCategories
      }
    });

    globalEvent({
      type: 'click',
      event: {
        action: 'collapse-sub-categories',
        callback: PageSubCategoryExpander.collapseSubCategories
      }
    });

    PageSubCategoryExpander.calculateSubCategories();
  }

  static expandSubCategories = (event): void => {
    event.preventDefault();
    event.stopPropagation();

    const subCategoriesElement = element('.sub-categories') as HTMLElement;
    if (!subCategoriesElement) return;

    const expandElement = element(
      '[data-action="show-all-sub-categories"]'
    ) as HTMLElement;
    const collapseElement = element(
      '[data-action="collapse-sub-categories"]'
    ) as HTMLElement;
    if (expandElement) {
      addCss(expandElement, 'hidden');
    }
    if (collapseElement) {
      removeCss(collapseElement, 'hidden');
    }

    subCategoriesElement.style.height = 'unset';
  };

  static collapseSubCategories = (event): void => {
    event.preventDefault();
    event.stopPropagation();

    const subCategoriesElement = element('.sub-categories') as HTMLElement;
    if (!subCategoriesElement) return;

    const expandElement = element(
      '[data-action="show-all-sub-categories"]'
    ) as HTMLElement;
    const collapseElement = element(
      '[data-action="collapse-sub-categories"]'
    ) as HTMLElement;
    if (expandElement) {
      removeCss(expandElement, 'hidden');
    }
    if (collapseElement) {
      addCss(collapseElement, 'hidden');
    }

    subCategoriesElement.style.height = '';
  };

  static calculateSubCategories = (): void => {
    const subCategoriesElement = element('.sub-categories') as HTMLElement;
    if (!subCategoriesElement) return;

    // Dont show link
    if (subCategoriesElement.scrollHeight > subCategoriesElement.clientHeight) {
      const expandElement = element(
        '[data-action="show-all-sub-categories"]'
      ) as HTMLElement;
      removeCss(expandElement, 'hidden');
    }
  };
}
